import { render, staticRenderFns } from "./ShipactivitiesFormSheet.vue?vue&type=template&id=28294473"
import script from "./ShipactivitiesFormSheet.vue?vue&type=script&lang=js"
export * from "./ShipactivitiesFormSheet.vue?vue&type=script&lang=js"
import style0 from "./ShipactivitiesFormSheet.vue?vue&type=style&index=0&id=28294473&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports